import { ConditionOperator } from '@aphp-ema/common/conditions/condition.schemas';

export const operatorTranslationKeys = {
  equals: 'pages.studies.questions.conditions.operators.equals',
  not_equals: 'pages.studies.questions.conditions.operators.not_equals',
  contains: 'pages.studies.questions.conditions.operators.contains',
  not_contains: 'pages.studies.questions.conditions.operators.not_contains',
  greater_than: 'pages.studies.questions.conditions.operators.greater_than',
  less_than: 'pages.studies.questions.conditions.operators.less_than',
  between: 'pages.studies.questions.conditions.operators.between',
  is_empty: 'pages.studies.questions.conditions.operators.is_empty',
  is_not_empty: 'pages.studies.questions.conditions.operators.is_not_empty',
} as const satisfies Record<ConditionOperator, string>;
